import { PropsWithChildren } from 'react';

export function PushNotificationsProvider({ children }: PropsWithChildren<{}>) {
    return <>{children}</>;
}
